import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './IsCommentsCheckbox.module.scss';

interface IProps {
	toggleIsCommentVisible: () => void;
	isCommentVisible: boolean;
	isDisabled: boolean;
}

export const IsCommentsCheckbox: React.FC<IProps> = React.memo(
	({ toggleIsCommentVisible, isCommentVisible, isDisabled }) => {
		return (
			<Form.Item className={style.container} name="isCommentVisible" data-test="IsCommentsCheckbox">
				<Checkbox onChange={toggleIsCommentVisible} checked={isCommentVisible} disabled={isDisabled}>
					<Text translationNameSpace="form" translationKey="commentsLabel" asFragment={true} />
				</Checkbox>
			</Form.Item>
		);
	},
);
